import "./analytics/analytics";
import "./add-to-cart/add-to-cart";
import "./accordion/accordion";
import "./conditional-details/conditional-details";
import "./video/video";
import "./tab/tab";
import "./tooltip/tooltip";
import "./price-snippet/price-snippet";
import "./trap-focus/trap-focus";
import "./drawer/drawer";
import "./toast/toast";
import "./localization-form/localization-form";
import "./aria-listbox/aria-listbox";
import "../cart/cart-api";
import "../cart/cart-content";
import "../cart/cart-upsell";
import "../cart/wedding-details-form";
import "../cart/shipping-protection";
import "./swatch-price-sync/swatch-price-sync";
import "./quantity-input/quantity-input";
import "./quantity-stepper/quantity-stepper";
import "./search-field/search-field";
import "./date-field/date-field";
import "./markup-modal/markup-modal";
import "./klaviyo/klaviyo-form";
import "../product-card/product-card";
import "./product-card-swatches/product-card-swatches";
import "./social-share/social-share";
import "./load-in-view/load-in-view";
import "./animate/animate";

import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination, Mousewheel, Thumbs, EffectCreative } from "swiper/modules";
import { register } from "swiper/element/bundle";
import "./dynamic-breadcrumb/dynamic-breadcrumb";
import "./relative-link/relative-link";

register();

window.loadSwiperFulfillPromise({
  Swiper,
  Autoplay,
  EffectFade,
  EffectCreative,
  Navigation,
  Pagination,
  Mousewheel,
  Thumbs,
});

window.scrapeSectionData = (container) => {
  const dataEl = container.querySelector("[data-section-data]");
  if (!dataEl) return {};

  try {
    return JSON.parse(dataEl.textContent);
  } catch {
    console.warn(`Error parsing data for`, dataEl);
    return {};
  }
};

window.productUrl = (handle) => {
  return `${window.routes.root_url === "/" ? "" : window.routes.root_url}/products/${handle}`;
};

window.formatMoney = (num, showTrailingZeros, currency = "USD") => {
  const fractionDigits = showTrailingZeros ? 2 : (num * 100) % 100 === 0 ? 0 : 2;

  return new Intl.NumberFormat("en-EN", {
    style: "currency",
    currencyDisplay: "narrowSymbol",
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(num);
};

window.handleize = (string) => {
  string = string.toLowerCase();

  const toReplace = ['"', "'", "\\", "(", ")", "[", "]"];

  for (let i = 0; i < toReplace.length; ++i) {
    string = string.replace(toReplace[i], "");
  }

  string = string.replace(/\W+/g, "-");

  if (string.charAt(string.length - 1) == "-") {
    string = string.replace(/-+\z/, "");
  }

  if (string.charAt(0) == "-") {
    string = string.replace(/\A-+/, "");
  }

  return string;
};

window.getSizedImageUrl = (src, size) => {

  if (typeof src !== "undefined") {
    return src.replace(/\.jpg|\.png|\.webp|\.gif|\.jpeg/g, (match) => {
      return `_${size}${match}`;
    });
  } else {
    return "";
  }
};

window.fetchPageData = async ({ path, options = {} }) => {
  if (!path) return {};

  const { templateSuffix, sectionId, variantId } = options;
  const queryArray = [];

  if (templateSuffix) queryArray.push(`view=${templateSuffix}`);
  if (sectionId) queryArray.push(`section_id=${sectionId}`);
  if (variantId) queryArray.push(`variant=${variantId}`);

  const url = `${path}?${queryArray.join("&")}`;
  let html = {};

  await fetch(url)
    .then((response) => response.text())
    .then((response) => {
      const elId = sectionId ? `shopify-section-${sectionId}` : "MainContent";
      html = new DOMParser().parseFromString(response, "text/html");
      html = html.getElementById(elId).innerHTML;
    })
    .catch(() => {
      console.warn(`Error fetching data from ${url}`);
    });

  return html;
};

const lockers = new Set();

window.lockScroll = (locker) => {
  lockers.add(locker);
  document.documentElement.style.overflow = "hidden";
};

window.unlockScroll = (locker) => {
  lockers.delete(locker);

  if (!lockers.size) {
    document.documentElement.style.overflow = null;
  }
};

window.themeBreakpoints = {
  phone: 600,
  tablet: 768,
  "tablet-wide": 1024,
  desktop: 1440,
  "desktop-large": 1600,
  "desktop-extra-large": 1920,
  "desktop-ultra-large": 2880,
};

(() => {
  const openers = new Set();

  const dimmer = document.querySelector(".below-header-dimmer");

  window.openDimmer = (opener) => {
    openers.add(opener);
    dimmer.classList.add("dimmer--active");
  };

  window.closeDimmer = (opener) => {
    openers.delete(opener);

    if (!openers.size) {
      dimmer.classList.remove("dimmer--active");
    }
  };
})();

(() => {
  const openers = new Set();

  const dimmer = document.querySelector(".full-screen-dimmer");

  window.openFullDimmer = (opener) => {
    openers.add(opener);
    dimmer.classList.add("dimmer--active");
  };

  window.closeFullDimmer = (opener) => {
    openers.delete(opener);

    if (!openers.size) {
      dimmer.classList.remove("dimmer--active");
    }
  };
})();

(() => {
  const initSelectFields = (container = document) => {
    container.querySelectorAll(".select-field").forEach((field) => {
      const select = field.querySelector(".showroom-select");

      if (!select) return;

      const updateState = () => {
        field.classList.toggle("is-selected", select.value !== "");
      };

      updateState();
      select.addEventListener("change", updateState);
    });
  };

  initSelectFields();
})();

window.theme.translations = function (stringObject, key, variables = {}) {
  let str = stringObject[key];

  if (!str) return "";

  return str.replace(/{{\s*(\w+)\s*}}/g, (match, varName) => {
    return variables[varName] !== undefined ? variables[varName] : "";
  });
};
